const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: ["/service"],
    exact: true,
    component: "Service",
  },
  {
    path: ["/softwaredevelopment"],
    exact: true,
    component: "SoftwareDevelopment",
  },
  {
    path: ["/zero-trust"],
    exact: true,
    component: "ZeroTrust",
  },
  {
    path: ["/privacy-policy"],
    exact: true,
    component: "PrivacyPolicy",
  },
  {
    path: ["/site-map"],
    exact: true,
    component: "SiteMap",
  },
];

export default routes;
